import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import {
	checkLocalSavedData,
	handleGameProgressUpdate,
	displayIndicator,
	displayTooltip,
	destroyTooltip,
	destroyIndicator,
	updateMiniLevel,
	playUISound,
	displayTutorialHand,
	playTabletUnlockAnimations,
	playNotificationAnimation,
	removeNotificationBell,
	destroyInstructions
} from "../helpers/levelManager"
import { createTopBar } from "../helpers/levelManager"
import { phaserOverlay } from "../helpers/planetBlocker"
export default class TabletScene extends Phaser.Scene {
	constructor() {
		super({ key: "TabletScene" })
	}

	init() {
		this.sceneW = this.cameras.main.width
		this.sceneH = this.cameras.main.height

		// Get scaling information
		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.templateY = scalingData.templateY

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		this.barcodeMiniGameBool = false
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager
		if (this.soundManager) {
			console.log("Sound Manager: " + this.soundManager + "My Stupid Log")
		}
		// Create background and tablet view
		this.createBackground()

		// Load user data
		this.loadUserData()

		// Create tablet buttons
		this.createTabletButtons()

		// Animate tablet appearance
		this.animateTablet()

		// Set visibility based on game progress
		this.updateButtonVisibility()

		createTopBar(this)

		let cockpitScene = this.scene.get("CockpitScene")
		cockpitScene.hideFeedingTray()

		// if (cockpitScene.instructionBg) cockpitScene.instructionBg.setVisible(false)
		// if (cockpitScene.instructionText)
		// 	cockpitScene.instructionText.setVisible(false)

		destroyInstructions(cockpitScene)

		//this.createBarcodeMiniGame(closeFunction);
		
		this.cockpitScene = this.scene.get("CockpitScene")

		//DEBUG
		//this.showHelpDeskButton()		
	}

	createBarcodeMiniGame(closeFunction) {
		this.createBackground02(closeFunction)
	}
	//main tablet background
	createBackground() {
		this.transparentBG = this.add
			.image(this.sceneW / 2, this.sceneH / 2, "wideContainer")
			.setOrigin(0.5)
			.setScale(200)
			.setTint(0xcdfdff)
			.setAlpha(0.75)

		this.tabletView = this.add
			.image(this.sceneW / 2, this.sceneH / 2, "tabletView")
			.setOrigin(0.5)
			.setScale(0) // Start with scale 0 for animation
	}

	removeNotification() {
		if (this.notificationBell) {
			this.notificationBell.destroy()
		}
	}

	removeUnlockAnim() {
		if (this.unlockSprite) {
			this.unlockSprite.destroy()
		}
	}

	//scan barcode minigame
	createBackground02(closeFunction) {
		this.barcodeMiniGameBool = true
		console.log("Barcode Mini Game Started = " + this.barcodeMiniGameBool)
		this.transparentBG02 = this.add
			.image(this.sceneW / 2, this.sceneH / 2, "creatureSkin")
			.setOrigin(0.5)
			.setScale(200)
			.setTint(0xcdfdff)
			.setAlpha(0.45)

		this.tabletView2 = this.add
			.image(
				this.sceneW / 2,
				this.sceneH / 2 + 11 * this.scaleFactor,
				"tabletBG",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor, this.scaleFactor * 1.025)
			.setAlpha(1)
			.setDepth(9)

		this.closeBarcodeMiniGame = this.add
			.image(
				this.tabletView2.x + 220 * this.scaleFactor,
				this.tabletView2.y - 110 * this.scaleFactor,
				"closeButton",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setDepth(10)
			.setInteractive()
			.setVisible(true)

		this.firstScanButton = this.add
			.image(this.tabletView2.x, this.tabletView2.y, "barcodeScan")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setDepth(10)
			.setInteractive()
			.setVisible(true)

		displayTooltip(this, {
			xPos: this.firstScanButton.x,
			yPos: this.firstScanButton.y - 75 * this.scaleFactor,
			type: "noBarcodeScanTip",
			scale: 1,
			text: "The barcode cannot be read!\nPress this button to capture it.",
			fontScale: -8,
			xTextOffset: 0,
			yTextOffset: -6,
			wrapWidth: 1.1,
		})
		this.tooltip.setDepth(15)
		this.tooltipText.setDepth(16)
		console.log("TOOLTIP DISPLAYED!!!")

		this.howToScan = this.add.image(
			this.sceneW / 2,
			this.sceneH / 2 + 25 * this.scaleFactor,
			"howToScanPanel"
		).setScale(this.scaleFactor * 0.35).setDepth(10).setVisible(false)

		this.startButton = this.add
			.image(
				this.tabletView2.x + 160 * this.scaleFactor,
				this.howToScan.y + 85 * this.scaleFactor,
				"activeButton",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.4)
			.setDepth(10)
			.setInteractive()
			.setVisible(false)

		this.startText = this.add
			.text(
				this.startButton.x,
				this.startButton.y - 5 * this.scaleFactor,
				"START",
				{
					fontSize: this.fontSize + 5 * this.scaleFactor,
					fill: "#fff",
					resolution: 2,
					fontFamily: "Gluten",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
			.setDepth(11)
			.setVisible(false)

		this.firstScanButton.on("pointerdown", () => {
			destroyTooltip(this)
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			console.log("First Scan Button Clicked")
			this.firstScanButton.setVisible(false)
			this.startButton.setVisible(true)
			this.startText.setVisible(true)
			this.animalBG.setVisible(true)
			this.howToScan.setVisible(true)
			//this.barcodeChecker.setVisible(true)
			// this.scanButton.setVisible(true)
			// this.scanButton.setAlpha(0.5)
			// this.scanButton.input.enabled = false

			// displayTooltip(this, {
			// 	xPos: this.scanButton.x,
			// 	yPos: this.scanButton.y - 75 * this.scaleFactor,
			// 	type: "highlightBarcodeTip",
			// 	scale: 1,
			// 	text: "Press the scan button\nwhen the barcode is\nin the highlighted area above",
			// 	fontScale: -8,
			// 	xTextOffset: 0,
			// 	yTextOffset: -10,
			// 	wrapWidth: 1.1,
			// })

			// this.tooltip.setDepth(15)
			// this.tooltipText.setDepth(16)
			console.log("TOOLTIP 02 DISPLAYED!!!")
		})

		this.startButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			console.log("Start Button Clicked")
			this.startButton.setVisible(false)
			this.startText.setVisible(false)
			this.scanButton.setAlpha(1)
			this.scanButton.setVisible(true)
			this.howToScan.setVisible(false)
			this.scanButton.input.enabled = true
			this.barcodeChecker.setVisible(true)
			this.movingBarcode.setVisible(true)
			movingBarcodeAnimation.play()
			// this.barcodeChecker.setPosition(
			// 	this.tabletView2.x,
			// 	this.tabletView2.y + 10 * this.scaleFactor,
			// )
			destroyTooltip(this)
		})

		this.animalBG = this.add
			.image(
				this.sceneW / 2,
				this.sceneH / 2 + 11 * this.scaleFactor,
				"creatureSkin",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.3)
			.setDepth(9)
			.setVisible(false)

		const mask = this.tabletView2.createBitmapMask()
		this.animalBG.setMask(mask)
		let bottomValue = +130
		let topValue = -101

		this.movingBarcode = this.add
			.image(
				this.sceneW / 2 + 5 * this.scaleFactor,
				this.tabletView2.y + 156 * this.scaleFactor,
				"movingBarcode",
			)
			.setOrigin(0.5, 0.5)
			.setScale(this.scaleFactor * 0.5)
			.setDepth(9)
			.setVisible(false)

		this.barcodeChecker = this.add
			.image(
				this.sceneW / 2 + 5 * this.scaleFactor,
				this.tabletView2.y - 30 * this.scaleFactor,
				"barcodeChecker",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setDepth(16)
			.setVisible(false)

		this.scanButton = this.add
			.image(
				this.sceneW / 2,
				this.tabletView2.y + 119 * this.scaleFactor,
				"barcodeScan",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.4)
			.setDepth(9)
			.setInteractive()
			.setVisible(false)

		let movingBarcodeAnimation = this.tweens.add({
			targets: this.movingBarcode,
			y: {
				from: this.tabletView2.y + bottomValue * this.scaleFactor,
				to: this.tabletView2.y + topValue * this.scaleFactor,
				duration: 3000,
				ease: "sine.inOut",
				yoyo: true,
				repeat: -1,
			},
		})

		movingBarcodeAnimation.pause()
		let barcodeSuccessful = this.add
			.image(
				this.sceneW / 2,
				this.tabletView2.y - 80 * this.scaleFactor,
				"barcodeSuccess",
			)
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 0.5)
			.setDepth(9)
			.setVisible(false)

		let barcodeSuccessfulText = this.add
			.text(
				barcodeSuccessful.x,
				barcodeSuccessful.y + 140 * this.scaleFactor,
				"Close this window to return to the creature details.",
				{
					fontFamily: "Space Grotesk",
					fontSize: this.fontSize - 6 * this.scaleFactor,
					color: "#11044E",
					align: "center",
					fontWeight: "400",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
			.setDepth(9)
			.setVisible(false)

		const heightMultiplier = 0.8 // 80% of the original height

		this.scanButton.on("pointerdown", () => {
			const checkerHalfHeight = (this.barcodeChecker.displayHeight * heightMultiplier) / 2;

			console.log("Barcode Y:", this.movingBarcode.y);
			console.log("Checker Y:", this.barcodeChecker.y);
			console.log("Checker Half Height:", checkerHalfHeight);
			console.log("Valid Range:",
				this.barcodeChecker.y - checkerHalfHeight,
				"to",
				this.barcodeChecker.y + checkerHalfHeight
			);

			if (
				this.movingBarcode.y > this.barcodeChecker.y - checkerHalfHeight &&
				this.movingBarcode.y < this.barcodeChecker.y + checkerHalfHeight
			) {
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				console.log("Scanned")

				movingBarcodeAnimation.stop()

				this.movingBarcode.setPosition(
					this.sceneW / 2 + 5 * this.scaleFactor,
					this.tabletView2.y,
				)

				this.animalBG.setVisible(false)
				this.transparentBG02.setVisible(false)
				this.barcodeChecker.setVisible(false)
				this.scanButton.setVisible(false)
				barcodeSuccessfulText.setVisible(true)
				barcodeSuccessful.setVisible(true)
			} else {
				console.log("not Scanned")
			}
		})

		this.closeBarcodeMiniGame.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			barcodeSuccessfulText.setVisible(false)
			barcodeSuccessful.setVisible(false)
			this.tabletView2.setVisible(false)
			this.movingBarcode.setVisible(false)
			this.closeBarcodeMiniGame.setVisible(false)
			this.loadUserData()
			updateMiniLevel(this.savedMiniLevel)

			if (closeFunction) {
				closeFunction()
				console.log("WEIEIEIWUEI")
				this.barcodeMiniGameBool = false
				console.log(
					"Barcode Mini Game Still Started = " + this.barcodeMiniGameBool,
				)
			}
		})
	}

	loadUserData() {
		this.savedUserData = checkLocalSavedData()
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 0
		this.alertsOpened = this.savedUserData?.alertsOpened
		this.emailsOpened = this.savedUserData?.emailsOpened

		console.log(
			"SAVED MINI LEVEL: " +
			this.savedMiniLevel +
			"CURRENT PLANET: " +
			this.currentPlanet,
		)
	}

	createTabletButtons() {
		// Create close tablet button (commented out in original)
		this.createCloseTabletButton()

		// Create app buttons
		this.createAppButtons()
	}

	createCloseTabletButton() { }

	createAppButtons() {
		let cockpitScene = this.scene.get("CockpitScene")

		this.tabletViewGroup = this.add.group()
		this.tabletViewGroup.add(this.tabletView)

		let xOffset = 140
		let yOffset = 65

		let fontScaleOffset
		// More reliable device detection
		const isAndroidDevice = /android/i.test(navigator.userAgent)
		const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent)

		// Better way to detect desktop (by exclusion)
		const isMobile = isAndroidDevice || isIOSDevice

		fontScaleOffset = isMobile ? -5 : 5

		//fontScaleOffset = 5

		this.dataBaseHolder = this.add
			.image(
				this.tabletView.x - xOffset * this.scaleFactor,
				this.tabletView.y - yOffset * this.scaleFactor,
				"appHolder",
			)
			.setOrigin(0.5)
			.setScale(0)
		// Database Button
		this.databaseButton = this.add
			.image(
				this.tabletView.x - xOffset * this.scaleFactor,
				this.tabletView.y - yOffset * this.scaleFactor,
				"databaseButton",
			)
			.setOrigin(0.5)
			.setScale(0)
			.setAlpha(1)
			.setInteractive()
		this.databasetext = this.add
			.text(
				this.databaseButton.x - 1 * this.scaleFactor,
				this.databaseButton.y + 59 * this.scaleFactor,
				"Database",
				{
					fontFamily: "Gluten",
					fontSize: 26,
					color: "#11044E",
					align: "center",
					fontStyle: "bold",
					fontWeight: "700",
					resolution: 2,
				},
			)
			.setOrigin(0.5)

		this.databaseButton.on(
			"pointerdown",
			function () {
				if (this.barcodeMiniGameBool) {
					return
				}
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				removeNotificationBell()
				this.destroyUnlockAnims()
				this.scene.pause("TabletScene")
				this.scene.launch("CreatureDatabase")
				destroyTooltip(this)
				destroyIndicator(this)
				// this.cameras.main.fadeOut(500, 0, 0, 0).once('camerafadeoutcomplete', () => {
				//     this.scene.launch('CreatureDatabase');
				// });
			},
			this,
		)
		this.tabletViewGroup.add(this.databaseButton)
		this.tabletViewGroup.add(this.dataBaseHolder)
		this.tabletViewGroup.add(this.databasetext)

		// Field Guide Button
		this.fieldGuideButtonHolder = this.add
			.image(
				this.tabletView.x,
				this.tabletView.y - yOffset * this.scaleFactor,
				"appHolder",
			)
			.setOrigin(0.5)
			.setScale(0)

		this.fieldGuideButton = this.add
			.image(
				this.tabletView.x,
				this.tabletView.y - yOffset * this.scaleFactor,
				"fieldGuideButton",
			)
			.setOrigin(0.5)
			.setScale(0)
			.setAlpha(1)
			.setInteractive()

		this.fieldGuideButtonText = this.add
			.text(
				this.fieldGuideButton.x - 1 * this.scaleFactor,
				this.fieldGuideButton.y + 59 * this.scaleFactor,
				"Field Guide",
				{
					fontFamily: "Gluten",
					//fontSize: this.fontSize - fontScaleOffset * this.scaleFactor,
					fontSize: 26,
					color: "#11044E",
					fontStyle: "bold",
					fontWeight: "700",
					align: "center",
					resolution: 2,
				},
			)
			.setOrigin(0.5)

		this.fieldGuideButton.on(
			"pointerdown",
			function () {
				if (this.barcodeMiniGameBool) {
					return
				}
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				// if (this.currentPlanet > 0 && this.currentPlanet < 3) {
				// 	if (this.savedMiniLevel === 1) {
				// 		// return;
				// 	}
				// 	if (this.savedMiniLevel === 2) {
				// 		handleGameProgressUpdate(cockpitScene)
				// 	}
				// 	if (this.savedMiniLevel === 8) {
				// 		console.log("Field Guide Opened Food Checked")
				// 		handleGameProgressUpdate(cockpitScene)
				// 	}
				// 	if (this.savedMiniLevel === 15) {
				// 		console.log("Field Guide Opened Food Logged")
				// 		handleGameProgressUpdate(cockpitScene)
				// 	}
				// }

				// if (this.currentPlanet === 3) {
				// 	if (this.savedMiniLevel === 5) {
				// 		handleGameProgressUpdate(cockpitScene)
				// 	}
				// 	if (this.savedMiniLevel === 13) {
				// 		handleGameProgressUpdate(cockpitScene)
				// 	}
				// 	if (this.savedMiniLevel === 20) {
				// 		handleGameProgressUpdate(cockpitScene)
				// 	}
				// }
				removeNotificationBell()
				destroyIndicator(this)
				destroyTooltip(this)
				this.destroyUnlockAnims()
				this.scene.pause("TabletScene")
				this.scene.launch("FieldGuide")
				// this.cameras.main.fadeOut(500, 0, 0, 0).once('camerafadeoutcomplete', () => {
				//     this.scene.launch('FieldGuide');
				// });
			},
			this,
		)
		this.tabletViewGroup.add(this.fieldGuideButton)
		this.tabletViewGroup.add(this.fieldGuideButtonHolder)
		this.tabletViewGroup.add(this.fieldGuideButtonText)

		// Email Button
		this.emailButtonHolder = this.add
			.image(
				this.tabletView.x + xOffset * this.scaleFactor,
				this.tabletView.y - yOffset * this.scaleFactor,
				"appHolder",
			)
			.setOrigin(0.5)
			.setScale(0)
		this.emailButton = this.add
			.image(
				this.tabletView.x + xOffset * this.scaleFactor,
				this.tabletView.y - yOffset * this.scaleFactor,
				"emailButton",
			)
			.setOrigin(0.5)
			.setScale(0)
			.setAlpha(1)
			.setInteractive()
		this.emailtext = this.add
			.text(
				this.emailButton.x - 1 * this.scaleFactor,
				this.emailButton.y + 59 * this.scaleFactor,
				"Emails",
				{
					fontFamily: "Gluten",
					// fontSize: this.fontSize - fontScaleOffset * this.scaleFactor,
					fontSize: 26,
					color: "#11044E",
					fontStyle: "bold",
					fontWeight: "700",
					align: "center",
					resolution: 2,
				},
			)
			.setOrigin(0.5)

		this.emailButton.on(
			"pointerdown",
			function () {
				if (this.barcodeMiniGameBool) {
					return
				}
				if (this.savedMiniLevel === 1 && this.currentPlanet === 1) {
					//return;
				}
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				removeNotificationBell()
				destroyIndicator(this)
				destroyTooltip(this)
				this.destroyUnlockAnims()
				this.scene.pause("TabletScene")
				this.scene.launch("Emails")
			},
			this,
		)
		this.tabletViewGroup.add(this.emailButton)
		this.tabletViewGroup.add(this.emailButtonHolder)
		this.tabletViewGroup.add(this.emailtext)

		// Alerts Button
		this.alertsButtonHolder = this.add
			.image(
				this.tabletView.x - xOffset * this.scaleFactor,
				this.tabletView.y + 25 + yOffset * this.scaleFactor,
				"appHolder",
			)
			.setOrigin(0.5)
			.setScale(0)
		this.alertsButton = this.add
			.image(
				this.tabletView.x - xOffset * this.scaleFactor,
				this.tabletView.y + 25 + yOffset * this.scaleFactor,
				"alertsButton",
			)
			.setOrigin(0.5)
			.setScale(0)
			.setAlpha(1)
			.setInteractive()
		this.alertstext = this.add
			.text(
				this.alertsButton.x - 1 * this.scaleFactor,
				this.alertsButton.y + 59 * this.scaleFactor,
				"Alerts",
				{
					fontFamily: "Gluten",
					// fontSize: this.fontSize - fontScaleOffset * this.scaleFactor,
					fontSize: 26,
					color: "#11044E",
					fontStyle: "bold",
					fontWeight: "700",
					align: "center",
					resolution: 2,
				},
			)
			.setOrigin(0.5)

		this.alertsButton.on(
			"pointerdown",
			function () {
				if (this.barcodeMiniGameBool) {
					return
				}
				if (this.savedMiniLevel === 1 && this.currentPlanet === 1) {
					//return;
				}
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				destroyIndicator(this)
				destroyTooltip(this)
				removeNotificationBell()
				this.destroyUnlockAnims()
				this.scene.pause("TabletScene")
				this.scene.launch("Alerts")
				// this.cameras.main.fadeOut(500, 0, 0, 0).once('camerafadeoutcomplete', () => {
				//     this.scene.launch('Alerts');
				// });
			},
			this,
		)

		this.helpDeskButtonHolder = this.add
			.image(
				this.fieldGuideButton.x,
				this.tabletView.y + 25 + yOffset * this.scaleFactor,
				"appHolder",
			)
			.setOrigin(0.5)
			.setScale(0)
			.setVisible(false)

		this.helpDeskButton = this.add
			.image(
				this.fieldGuideButton.x,
				this.tabletView.y + 25 + yOffset * this.scaleFactor,
				"helpDeskButton",
			)
			.setOrigin(0.5)
			.setScale(0)
			.setAlpha(1)
			.setInteractive()
			.setVisible(false)
		this.helpDesktext = this.add
			.text(
				this.helpDeskButton.x - 1 * this.scaleFactor,
				this.helpDeskButton.y + 59 * this.scaleFactor,
				"Help Desk",
				{
					fontFamily: "Gluten",
					// fontSize: this.fontSize - fontScaleOffset * this.scaleFactor,
					fontSize: 26,
					color: "#11044E",
					fontStyle: "bold",
					fontWeight: "700",
					align: "center",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
			.setVisible(false)

		this.helpDeskButton.on(
			"pointerdown",
			function () {
				if (this.barcodeMiniGameBool) {
					return
				}
				console.log("Help Desk Button Pressed")
				if (this.currentPlanet <= 2) {
					// return;
				}
				//playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				destroyIndicator(this)
				destroyTooltip(this)
				removeNotificationBell()
				this.destroyUnlockAnims()
				this.scene.pause("TabletScene")
				this.scene.launch("HelpDesk")
			},
			this,
		)

		if (this.currentPlanet >= 3 && this.savedMiniLevel >= 16) {
			this.loadUserData()
			let otpAlertOpened = this.alertsOpened["otpAlert"]
			if (otpAlertOpened) {
				console.log("OTP ALERT OPENED")
				this.showHelpDeskButton()
			}
		}

		this.tabletViewGroup.add(this.alertsButton)
		this.tabletViewGroup.add(this.alertsButtonHolder)
		this.tabletViewGroup.add(this.alertstext)

		this.tabletViewGroup.add(this.helpDeskButton)
		this.tabletViewGroup.add(this.helpDeskButtonHolder)
		this.tabletViewGroup.add(this.helpDesktext)

		//DEBUG
		// this.showHelpDeskButton()
	}

	showHelpDeskFirstTime() {
		this.helpDeskButtonHolder.setVisible(true)
		this.helpDeskButton.setVisible(true)
		this.helpDesktext.setVisible(true)

		// this.notificationBell = this.add
		// 	.image(
		// 		this.helpDeskButton.x + 50 * this.scaleFactor,
		// 		this.helpDeskButton.y - 50 * this.scaleFactor,
		// 		"notificationBell",
		// 	)
		// 	.setOrigin(0.5)
		// 	.setScale(this.scaleFactor / 2)

		playNotificationAnimation(this, {
			xPos: this.helpDeskButton.x + 50 * this.scaleFactor,
			yPos: this.helpDeskButton.y - 50 * this.scaleFactor,
		})

		displayIndicator(
			this,
			this.helpDeskButton.x,
			this.helpDeskButton.y,
			1,
			"tabAppIndicator",
		)
	}

	showHelpDeskButton() {
		this.helpDeskButtonHolder.setVisible(true)
		this.helpDeskButton.setVisible(true)
		this.helpDesktext.setVisible(true)
	}



	animateTablet() {
		this.tabletViewGroup.getChildren().forEach((child) => {
			let scale =
				child === this.tabletView ? this.scaleFactor : this.scaleFactor * 0.5
			//scale = this.scaleFactor;
			this.tweens.add({
				targets: child,
				scale: scale,
				duration: 500,
				ease: "Back.out",
			})
		})
	}

	destroyUnlockAnims() {
		if (this.unlockSprite) {
			this.unlockSprite.destroy()
		}
	}

	// removeNotificationBell() {
	// 	;[this.notificationBell, this.notificationBell02, this.notificationBell03]
	// 		.filter((bell) => !!bell)
	// 		.forEach((bell) => bell.destroy())
	// }

	extAddNotificationBell(buttonName) {
		if (!this.notificationBell) {
			return
		}
		const buttons = {
			databaseButton: this.databaseButton,
			fieldGuideButton: this.fieldGuideButton,
			emailsButton: this.emailsButton,
			alertsButton: this.alertsButton,
			helpDeskButton: this.helpDeskButton,
		}

		const button = buttons[buttonName]
		if (button) {
			// this.notificationBell = this.add
			// 	.image(
			// 		button.x + 50 * this.scaleFactor,
			// 		button.y - 50 * this.scaleFactor,
			// 		"notificationBell",
			// 	)
			// 	.setOrigin(0.5)
			// 	.setScale(this.scaleFactor / 2)
			console.log("Show Notification Animation")
			playNotificationAnimation(this,
				{
					xPos: button.x + 50 * this.scaleFactor,
					yPos: button.y - 50 * this.scaleFactor
				}
			)
		}
	}

	/**
	 * Update visibility of buttons based on current planet and level
	 */
	updateButtonVisibility() {
		console.log(
			"CURRENT PLANET: " +
			this.currentPlanet +
			" MINI LEVEL: " +
			this.savedMiniLevel,
		)
		// Helper function to add notification bell to a button
		function addNotificationBell(scene, button) {
			if (scene.currentPlanet <= 2) {
				//displayIndicator(scene, button.x, button.y, 1, "tabAppIndicator")
			}

			playNotificationAnimation(scene,
				{
					xPos: button.x + 50 * scene.scaleFactor,
					yPos: button.y - 50 * scene.scaleFactor
				}
			)
			// return scene.add
			// 	.image(
			// 		button.x + 50 * scene.scaleFactor,
			// 		button.y - 50 * scene.scaleFactor,
			// 		"notificationBell",
			// 	)
			// 	.setOrigin(0.5)
			// 	.setScale(scene.scaleFactor / 2)
			return
		}

		// Helper function to show tooltip
		function showTooltip(scene, button, text, type, placement) {
			let wrapWidthValue = 1.01
			// let laptop = scene.sys.game.device.os.laptop
			// let desktop = scene.sys.game.device.os.desktop
			// if (laptop || desktop) {
			// 	wrapWidthValue = 2
			// }
			if (type === "logActivityTip") {
				wrapWidthValue = 1.01
			}
			if (placement) {
				wrapWidthValue = 1.01
			}
			displayTooltip(scene, {
				xPos: button.x,
				yPos: button.y + 110 * scene.scaleFactor,
				type: type,
				scale: 1,
				text: text,
				fontScale: -8,
				xTextOffset: 2,
				yTextOffset: 3,
				wrapWidth: wrapWidthValue,
			})
		}

		// Configure notifications and tooltips based on planet and level
		if (this.currentPlanet === 1) {
			switch (this.savedMiniLevel) {
				case 1:
					addNotificationBell(this, this.databaseButton)

					// Lock all buttons except database
					this.alertsButton.input.enabled = false
					this.alertsButton.setTexture("alertsLocked")
					this.emailButton.input.enabled = false
					this.emailButton.setTexture("emailLocked")
					this.fieldGuideButton.input.enabled = false
					this.fieldGuideButton.setTexture("fieldGuideLocked")

					showTooltip(
						this,
						this.databaseButton,
						"This is the [b]‘Database’[/b] app.\nThe scan results are here!",
						"downMediumBigTip",
					)

					displayTutorialHand(this, {
						xPos: this.databaseButton.x + 90 * this.scaleFactor,
						yPos: this.databaseButton.y + 60 * this.scaleFactor,
						rotation: -35,
					})

					const overlay = phaserOverlay(this)
					overlay.setTargetByCoords(
						this.databaseButton.x - this.databaseButton.width * this.scaleFactor / 2 + 25 * this.scaleFactor,
						this.databaseButton.y - this.databaseButton.height * this.scaleFactor / 2 + 25 * this.scaleFactor,
						this.databaseButton.width * this.scaleFactor - 50 * this.scaleFactor,
						this.databaseButton.height * this.scaleFactor - 50 * this.scaleFactor,
					)

					overlay.setAboveOverlay([this.tooltip, this.tooltipText, this.tutorialHand])
					console.log("BLOCKED 01")
					break

				case 2:
					this.notificationBell = addNotificationBell(
						this,
						this.fieldGuideButton,
					)

					// Lock alerts and email, but enable field guide
					this.alertsButton.input.enabled = false
					this.alertsButton.setTexture("alertsLocked")
					this.emailButton.input.enabled = false
					this.emailButton.setTexture("emailLocked")
					this.fieldGuideButton.input.enabled = true
					this.fieldGuideButton.setTexture("fieldGuideButton")

					//displayTooltip(this, this.fieldGuideButton.x, this.fieldGuideButton.y + 130 * this.scaleFactor, 'medium', 'Down', 'Open the 'Fieldguide' app to search for information about what your creature eats.', 17)
					// if (this.sys.game.device.os.desktop || this.sys.game.device.os.laptop) {
					//     console.log("DATABASE BUTTON UNLOCKED");
					// }
					// else {
					//     showTooltip(this, this.fieldGuideButton,
					//         "Open the ‘Field Guide’ app\nto search for information\nabout what your creature eats.");
					// }

					showTooltip(
						this,
						this.fieldGuideButton,
						"Open the [b]‘Field Guide’[/b] app\nto find out what\nyour creature eats.",
						"downMediumBigTip",
					)

					//Unlock Animation
					playTabletUnlockAnimations(this,
						{
							xPos: this.fieldGuideButton.x,
							yPos: this.fieldGuideButton.y
						}
					)

					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})

					displayTutorialHand(this, {
						xPos: this.fieldGuideButton.x - 110 * this.scaleFactor,
						yPos: this.fieldGuideButton.y + 45 * this.scaleFactor,
						rotation: 55,
					})

					const overlay00 = phaserOverlay(this)
					overlay00.setTargetByCoords(
						this.fieldGuideButton.x - this.fieldGuideButton.width * this.scaleFactor / 2 + 25 * this.scaleFactor,
						this.fieldGuideButton.y - this.fieldGuideButton.height * this.scaleFactor / 2 + 25 * this.scaleFactor,
						this.fieldGuideButton.width * this.scaleFactor - 50 * this.scaleFactor,
						this.fieldGuideButton.height * this.scaleFactor - 50 * this.scaleFactor,
					)

					overlay00.setAboveOverlay([this.tutorialHand, this.notificationBell, this.tooltip, this.tooltipText])

					console.log("BLOCKED 02")
					break

				case 3:
					this.notificationBell = addNotificationBell(this, this.databaseButton)

					this.alertsButton.input.enabled = false
					this.alertsButton.setTexture("alertsLocked")
					this.emailButton.input.enabled = false
					this.emailButton.setTexture("emailLocked")

					//displayTooltip(this, this.databaseButton.x, this.databaseButton.y + 130 * this.scaleFactor, 'medium', 'Down', 'Log what you fed your creature in the 'Activity Log' tab inside the 'Database' App', 17)
					showTooltip(
						this,
						this.databaseButton,
						"The [b]‘Activity Log’[/b] is in the [b]‘Database'[/b]",
						"logActivityTip",
					)

					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})

					displayTutorialHand(this, {
						xPos: this.databaseButton.x + 90 * this.scaleFactor,
						yPos: this.databaseButton.y + 50 * this.scaleFactor,
						rotation: -35,
					})

					const overlay02 = phaserOverlay(this)
					overlay02.setTargetByCoords(
						this.databaseButton.x - this.databaseButton.width * this.scaleFactor / 2 + 25 * this.scaleFactor,
						this.databaseButton.y - this.databaseButton.height * this.scaleFactor / 2 + 10 * this.scaleFactor,
						this.databaseButton.width * this.scaleFactor - 50 * this.scaleFactor,
						this.databaseButton.height * this.scaleFactor - 50 * this.scaleFactor,
					)

					overlay02.setAboveOverlay([this.tooltip, this.tooltipText, this.tutorialHand])
					console.log("BLOCKED 03")
					break

				case 4:
					this.notificationBell = addNotificationBell(this, this.emailButton)

					this.alertsButton.input.enabled = false
					this.alertsButton.setTexture("alertsLocked")

					//displayTooltip(this, this.emailButton.x, this.emailButton.y + 130 * this.scaleFactor, 'medium', 'Down', 'You have successfully unlocked the 'Email' app! It appears that you already have your first message.', 17)
					showTooltip(
						this,
						this.emailButton,
						"[b]‘Email’[/b] app unlocked!\nYou have 1 message.",
						"downMediumTip",
						true,
					)

					//Unlock Animation
					playTabletUnlockAnimations(this,
						{
							xPos: this.emailButton.x,
							yPos: this.emailButton.y
						}
					)

					displayTutorialHand(this, {
						xPos: this.emailButton.x - 110 * this.scaleFactor,
						yPos: this.emailButton.y + 45 * this.scaleFactor,
						rotation: 55,
					})

					playNotificationAnimation(this, {
						xPos: this.emailButton.x + 50 * this.scaleFactor,
						yPos: this.emailButton.y - 50 * this.scaleFactor,
					})
					break

				case 6:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})

					displayTutorialHand(this, {
						xPos: this.databaseButton.x + 90 * this.scaleFactor,
						yPos: this.databaseButton.y + 50 * this.scaleFactor,
						rotation: -35,
					})
					console.log("Showing Here ===> 1")
					//displayIndicator(this, this.databaseButton.x, this.databaseButton.y, this.scaleFactor * 2, this.scaleFactor)
					displayIndicator(
						this,
						this.databaseButton.x,
						this.databaseButton.y,
						1,
						"tabAppIndicator",
					)
					this.alertsButton.input.enabled = false
					this.alertsButton.setTexture("alertsLocked")

					break

				// case 7:
				//     this.notificationBell = this.add.image(this.fieldGuideButton.x + 50 * this.scaleFactor, this.fieldGuideButton.y - 50 * this.scaleFactor, 'notificationBell').setOrigin(0.5).setScale(this.scaleFactor);
				//     break;

				case 8:
					console.log("Get creature 02 food")
					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})

					displayTutorialHand(this, {
						xPos: this.fieldGuideButton.x + 90 * this.scaleFactor,
						yPos: this.fieldGuideButton.y + 50 * this.scaleFactor,
						rotation: -35,
					})

					this.alertsButton.input.enabled = false
					this.alertsButton.setTexture("alertsLocked")
					break

				case 9:
					console.log("Log creature 02 food")
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})

					displayTutorialHand(this, {
						xPos: this.databaseButton.x + 90 * this.scaleFactor,
						yPos: this.databaseButton.y + 50 * this.scaleFactor,
						rotation: -35,
					})
					displayIndicator(
						this,
						this.databaseButton.x,
						this.databaseButton.y,
						1,
						"tabAppIndicator",
					)

					this.alertsButton.input.enabled = false
					this.alertsButton.setTexture("alertsLocked")
					break

				case 11:
					this.loadUserData()
					let facialScanOpened = this.alertsOpened["facialScan"]
					let requiredEmailsOpened = this.emailsOpened === 2
					console.log("Facial Scan Opened: " + facialScanOpened)
					removeNotificationBell()
					if (!facialScanOpened) {
						// this.notificationBell02 = addNotificationBell(
						// 	this,
						// 	this.alertsButton,
						// )

						playTabletUnlockAnimations(this,
							{
								xPos: this.alertsButton.x,
								yPos: this.alertsButton.y
							}
						)

						playNotificationAnimation(this, {
							xPos: this.alertsButton.x + 50 * this.scaleFactor,
							yPos: this.alertsButton.y - 50 * this.scaleFactor,
						})

						displayIndicator(
							this,
							this.alertsButton.x,
							this.alertsButton.y,
							1,
							"tabAppIndicator",
						)
					}

					if (facialScanOpened && !requiredEmailsOpened) {
						this.notificationBell03 = addNotificationBell(
							this,
							this.emailButton,
						)

						displayIndicator(
							this,
							this.emailButton.x,
							this.emailButton.y,
							1,
							"tabAppIndicator",
						)
					}

					break

				case 13:
					this.loadUserData()
					facialScanOpened = this.alertsOpened["facialScan"]
					requiredEmailsOpened = this.emailsOpened === 2
					removeNotificationBell()
					if (!facialScanOpened) {
						this.notificationBell02 = addNotificationBell(
							this,
							this.alertsButton,
						)

						displayIndicator(
							this,
							this.alertsButton.x,
							this.alertsButton.y,
							1,
							"tabAppIndicator",
						)
					}

					if (!requiredEmailsOpened) {
						this.notificationBell03 = addNotificationBell(
							this,
							this.emailButton,
						)

						displayIndicator(
							this,
							this.emailButton.x,
							this.emailButton.y,
							1,
							"tabAppIndicator",
						)
					}
					break
			}
		} else if (this.currentPlanet === 2) {
			switch (this.savedMiniLevel) {
				case 1:
					// this.notificationBell = addNotificationBell(this, this.databaseButton)
					// // displayIndicator(this, this.databaseButton.x, this.databaseButton.y, this.scaleFactor * 2, this.scaleFactor)
					// displayIndicator(
					// 	this,
					// 	this.databaseButton.x,
					// 	this.databaseButton.y,
					// 	1,
					// 	"tabAppIndicator",
					// )
					// console.log("BLOCKED 01")

					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})

					displayTutorialHand(this, {
						xPos: this.databaseButton.x + 90 * this.scaleFactor,
						yPos: this.databaseButton.y + 60 * this.scaleFactor,
						rotation: -35,
					})
					break

				case 2:
					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})

					displayTutorialHand(this, {
						xPos: this.fieldGuideButton.x - 110 * this.scaleFactor,
						yPos: this.fieldGuideButton.y + 45 * this.scaleFactor,
						rotation: 55,
					})
					//this.lockAlertsButton.setVisible(true);
					//this.lockEmailButton.setVisible(true);
					//this.lockFieldGuideButton.setVisible(false);
					this.alertsButton.input.enabled = false
					this.emailButton.input.enabled = false
					this.fieldGuideButton.input.enabled = true
					console.log("BLOCKED 02 ===== Here we are")
					break

				case 3:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})

					displayTutorialHand(this, {
						xPos: this.databaseButton.x + 90 * this.scaleFactor,
						yPos: this.databaseButton.y + 50 * this.scaleFactor,
						rotation: -35,
					})
					//this.lockAlertsButton.setVisible(false);
					//this.lockEmailButton.setVisible(true);
					//this.lockFieldGuideButton.setVisible(false);
					this.alertsButton.input.enabled = false
					this.emailButton.input.enabled = true
					displayIndicator(
						this,
						this.databaseButton.x,
						this.databaseButton.y,
						1,
						"tabAppIndicator",
					)
					// displayIndicator(this, this.databaseButton.x, this.databaseButton.y, this.scaleFactor, this.scaleFactor)
					console.log("BLOCKED 03")
					break

				case 5:
					this.loadUserData()
					let securityCheckOpened = this.alertsOpened["securityCheck"]
					removeNotificationBell()
					if (!securityCheckOpened) {
						playNotificationAnimation(this, {
							xPos: this.alertsButton.x + 50 * this.scaleFactor,
							yPos: this.alertsButton.y - 50 * this.scaleFactor,
						})
					}
					break

				case 6:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					// displayIndicator(this, this.databaseButton.x, this.databaseButton.y, this.scaleFactor * 2, this.scaleFactor)
					break

				case 8:
					console.log("Get creature 02 food")
					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})
					// displayIndicator(this, this.fieldGuideButton.x, this.fieldGuideButton.y, this.scaleFactor * 2, this.scaleFactor)
					break

				case 9:
					console.log("Log creature 02 food")
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					break

				case 11:
					// this.notificationBell = addNotificationBell(this, this.alertsButton)
					// displayIndicator(
					// 	this,
					// 	this.alertsButton.x,
					// 	this.alertsButton.y,
					// 	1,
					// 	"tabAppIndicator",
					// )
					playNotificationAnimation(this, {
						xPos: this.alertsButton.x + 50 * this.scaleFactor,
						yPos: this.alertsButton.y - 50 * this.scaleFactor,
					})
					break

				case 13:
					console.log("Case 13")

					if (this.cockpitScene.planet2Creature3ScaledIn) {
						playNotificationAnimation(this, {
							xPos: this.databaseButton.x + 50 * this.scaleFactor,
							yPos: this.databaseButton.y - 50 * this.scaleFactor,
						})
					}
					else {
						this.loadUserData()
						let restartDeviceOpened = this.alertsOpened["restartDevice"]
						removeNotificationBell()
						if (!restartDeviceOpened) {
							playNotificationAnimation(this, {
								xPos: this.alertsButton.x + 50 * this.scaleFactor,
								yPos: this.alertsButton.y - 50 * this.scaleFactor,
							})
						} else {
							let cockpitScene = this.scene.get("CockpitScene")
							console.log(
								"CockpitScene.creature3Bool: " + cockpitScene.creature3Bool,
							)
							if (cockpitScene.creature3Bool) {
								playNotificationAnimation(this, {
									xPos: this.databaseButton.x + 50 * this.scaleFactor,
									yPos: this.databaseButton.y - 50 * this.scaleFactor,
								})
							}
						}
					}


					break
				case 14:
					console.log("Case 14")
					break

				case 15:
					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})
					break
				case 16:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					break
				case 17:
					let requiredAlerts = []
					let requiredEmails = 0

					let alertsOpened = this.alertsOpened
					let emailsOpened = this.emailsOpened

					requiredAlerts = ["securityCheck", "restartDevice"]
					requiredEmails = 2

					let allAlertsOpened = requiredAlerts.every((alert) => alertsOpened[alert])
					let allEmailsOpened = emailsOpened === requiredEmails

					if (allAlertsOpened && allEmailsOpened) {

						removeNotificationBell(this)
					} else {
						const unopenedAlert = requiredAlerts.find((key) => !alertsOpened[key])
						console.log("Unopened alert", unopenedAlert)
						console.log(`Emails opened: ${emailsOpened}/${requiredEmails}`)

						if (!allAlertsOpened) {
							playNotificationAnimation(this, {
								xPos: this.alertsButton.x + 50 * this.scaleFactor,
								yPos: this.alertsButton.y - 50 * this.scaleFactor
							})
						} else if (!allEmailsOpened) {
							playNotificationAnimation(this, {
								xPos: this.emailButton.x + 50 * this.scaleFactor,
								yPos: this.emailButton.y - 50 * this.scaleFactor
							})
						}
					}
			}
		} else if (this.currentPlanet === 3) {
			switch (this.savedMiniLevel) {
				case 1:
					this.loadUserData()
					let reconnectDeviceOpened = this.alertsOpened["reconnectDevice"]
					removeNotificationBell()
					if (!reconnectDeviceOpened) {
						playNotificationAnimation(this, {
							xPos: this.emailButton.x + 50 * this.scaleFactor,
							yPos: this.emailButton.y - 50 * this.scaleFactor,
						})

						displayTutorialHand(this, {
							xPos: this.emailButton.x - 110 * this.scaleFactor,
							yPos: this.emailButton.y + 45 * this.scaleFactor,
							rotation: 55,
						})
						// displayIndicator(
						// 	this,
						// 	this.emailButton.x,
						// 	this.emailButton.y,
						// 	1,
						// 	"tabAppIndicator",
						// )
					}

					console.log("BLOCKED 01")
					break

				case 2:
					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})
					// displayIndicator(
					// 	this,
					// 	this.fieldGuideButton.x,
					// 	this.fieldGuideButton.y,
					// 	1,
					// 	"tabAppIndicator",
					// )
					//this.lockAlertsButton.setVisible(true);
					//this.lockEmailButton.setVisible(true);
					//this.lockFieldGuideButton.setVisible(false);
					this.alertsButton.input.enabled = false
					this.emailButton.input.enabled = false
					this.fieldGuideButton.input.enabled = true
					console.log("BLOCKED 02")
					break

				case 3:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					// displayIndicator(
					// 	this,
					// 	this.databaseButton.x,
					// 	this.databaseButton.y,
					// 	1,
					// 	"tabAppIndicator",
					// )
					//this.lockAlertsButton.setVisible(false);
					//this.lockEmailButton.setVisible(true);
					//this.lockFieldGuideButton.setVisible(false);
					this.alertsButton.input.enabled = false
					this.emailButton.input.enabled = true
					// displayIndicator(this, this.databaseButton.x, this.databaseButton.y, this.scaleFactor, this.scaleFactor)
					console.log("BLOCKED 03")
					break

				case 4:
					break

				case 5:
					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})
					// displayIndicator(
					// 	this,
					// 	this.fieldGuideButton.x,
					// 	this.fieldGuideButton.y,
					// 	1,
					// 	"tabAppIndicator",
					// )
					break

				case 6:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					//displayIndicator(this, this.databaseButton.x, this.databaseButton.y, this.scaleFactor * 2, this.scaleFactor)
					break

				case 8:
					this.loadUserData()
					let robotAlertOpened = this.alertsOpened["robotAlert"]
					removeNotificationBell()
					if (!robotAlertOpened) {
						playNotificationAnimation(this, {
							xPos: this.alertsButton.x + 50 * this.scaleFactor,
							yPos: this.alertsButton.y - 50 * this.scaleFactor,
						})
						// displayIndicator(
						// 	this,
						// 	this.alertsButton.x,
						// 	this.alertsButton.y,
						// 	1,
						// 	"tabAppIndicator",
						// )
					}
					break

				case 9:
					this.loadUserData()
					robotAlertOpened = this.alertsOpened["robotAlert"]
					removeNotificationBell()
					if (!robotAlertOpened) {
						playNotificationAnimation(this, {
							xPos: this.alertsButton.x + 50 * this.scaleFactor,
							yPos: this.alertsButton.y - 50 * this.scaleFactor,
						})
						// displayIndicator(
						// 	this,
						// 	this.alertsButton.x,
						// 	this.alertsButton.y,
						// 	1,
						// 	"tabAppIndicator",
						// )
					}

					break

				case 10:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					break

				case 11:
					playNotificationAnimation(this, {
						xPos: this.alertsButton.x + 50 * this.scaleFactor,
						yPos: this.alertsButton.y - 50 * this.scaleFactor,
					})
					break

				case 13:
					console.log("Case 13 Planet 3")
					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})
					//this.notificationBell = this.add.image(this.emailButton.x + 50 * this.scaleFactor, this.emailButton.y - 50 * this.scaleFactor, 'notificationBell').setOrigin(0.5).setScale(this.scaleFactor);
					break

				case 15:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					//this.notificationBell = this.add.image(this.emailButton.x + 50 * this.scaleFactor, this.emailButton.y - 50 * this.scaleFactor, 'notificationBell').setOrigin(0.5).setScale(this.scaleFactor);
					break

				case 16:
					this.loadUserData()
					let otpAlertOpened = this.alertsOpened["otpAlert"]
					removeNotificationBell()
					if (!otpAlertOpened) {
						playNotificationAnimation(this, {
							xPos: this.emailButton.x + 50 * this.scaleFactor,
							yPos: this.emailButton.y - 50 * this.scaleFactor,
						})
						// displayIndicator(
						// 	this,
						// 	this.emailButton.x,
						// 	this.emailButton.y,
						// 	1,
						// 	"tabAppIndicator",
						// )
					}

					break

				case 18:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					break

				case 20:
					playNotificationAnimation(this, {
						xPos: this.fieldGuideButton.x + 50 * this.scaleFactor,
						yPos: this.fieldGuideButton.y - 50 * this.scaleFactor,
					})
					break
				case 21:
					playNotificationAnimation(this, {
						xPos: this.databaseButton.x + 50 * this.scaleFactor,
						yPos: this.databaseButton.y - 50 * this.scaleFactor,
					})
					break
				case 23:
					let requiredAlerts = []
					let requiredEmails = 0

					let alertsOpened = this.alertsOpened
					let emailsOpened = this.emailsOpened

					requiredAlerts = ["otpAlert", "reconnectDevice", "robotAlert"]
					requiredEmails = 4

					let allAlertsOpened = requiredAlerts.every((alert) => alertsOpened[alert])
					let allEmailsOpened = emailsOpened === requiredEmails

					if (allAlertsOpened && allEmailsOpened) {

						removeNotificationBell(this)
					} else {
						const unopenedAlert = requiredAlerts.find((key) => !alertsOpened[key])
						console.log("Unopened alert", unopenedAlert)
						console.log(`Emails opened: ${emailsOpened}/${requiredEmails}`)

						if (!allAlertsOpened) {
							playNotificationAnimation(this, {
								xPos: this.alertsButton.x + 50 * this.scaleFactor,
								yPos: this.alertsButton.y - 50 * this.scaleFactor
							})
						} else if (!allEmailsOpened) {
							playNotificationAnimation(this, {
								xPos: this.emailButton.x + 50 * this.scaleFactor,
								yPos: this.emailButton.y - 50 * this.scaleFactor
							})
						}
					}
			}
		}
	}
}
